<template lang="pug">
  section.mercadojumbo
    .jumbo-wrapper
      h1 {{title}}
        small {{small}}
    .jumbo-bg
      VideoPlayer(video="content/loop-03.mp4")
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer'
export default {
  props: {
    title: String,
    small: String,
    img: String
  },
  components: {
    VideoPlayer
  }
}
</script>
<style lang="scss" scoped>
  section{
    position: relative;
    min-height: 50vh;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    .jumbo-bg{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      max-height: 60vh;
      padding-bottom: 3rem;
      overflow: hidden;
      &:before{
        content: '';
        left: 0;
        right: 0;
        bottom: -3px;
        position: absolute;
        z-index: 2;
        height: 30vh;
        background: linear-gradient(transparent, white);
      }
    }
    .jumbo-wrapper{
      padding: 1rem 2rem;
      position: relative;
      z-index: 3;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 2rem;
      h1{
        font-size: 6rem;
        @include fluid-type(360px, 1440px, 40px, 96px);
        color: white;
        text-align: center;
        max-width: 60%;
        @media (max-width: 800px){
          max-width: 100%;
          padding-left: 1rem;
          padding-right: 1rem;
        }
        text-transform: uppercase;
        text-shadow: 0 1px 1px rgba(0,0,0,.2), 0 -1px 3px rgba(0,0,0,.3);

        small{
          display: block;
          font-size: 2rem;
          @include fluid-type(360px, 1440px, 20px, 36px);
        }
      }
    }
  }
</style>

